import comp from "./ActivitySelector";

export default comp;
